import { api } from "@/api";
import { MatchStream } from "@/types/SportsApiResponses";

export interface SaveStreamsPayload {
  streams: MatchStream[];
  providerId: number | string;
  providerMatchId: number | string;
}

export const saveStreams = async (
  payload: SaveStreamsPayload
): Promise<MatchStream[]> => {
  const res = await api.client.post(`/matches/streams`, payload);
  return res.data;
};
